<!--
@create date 2023-11-27
@desc tattoo.phomemo.com
-->
<template>
  <div class="m08f-guide2-div">
    <div class="scroll-items-div">
      <ul>
        <li
          :class="
            clickName === 'howToVideosRef'
              ? 'every-click-item active-select-item'
              : 'every-click-item'
          "
          @click="turnToItem('howToVideosRef')"
        >
          HOW-TO VIDEOS
        </li>
        <li
          :class="
            clickName === 'driversRef'
              ? 'every-click-item active-select-item'
              : 'every-click-item'
          "
          @click="turnToItem('driversRef')"
        >
          DRIVERS
        </li>
        <li
          :class="
            clickName === 'appDownloadRef'
              ? 'every-click-item active-select-item'
              : 'every-click-item'
          "
          @click="turnToItem('appDownloadRef')"
        >
          APP
        </li>
        <li
          :class="
            clickName === 'faqRef'
              ? 'every-click-item active-select-item'
              : 'every-click-item'
          "
          @click="turnToItem('faqRef')"
        >
          FAQ
        </li>
      </ul>
    </div>
    <div class="topContainerDivEx" style="margin-bottom: 30px">
      <h1>M08F Tattto Stencil Printer Support</h1>
      <div class="productDiv">
        <div class="leftDiv">
          <img
            src="https://m.media-amazon.com/images/I/71tmU5UDiiL._SX466_.jpg"
            style="margin: 10px auto; width: 200px"
            title="Click to view the product."
            @click="
              () => {
                window.open('https://www.amazon.com/dp/B0BRMJ2MYW');
              }
            "
          />
        </div>
        <div class="rightDiv">
          <p>
            In addition to the printer support and repair resources on this
            page, also see the following:
          </p>
          <div class="linkDiv">
            <a
              target="_blank"
              title="Click to learn more"
              @click="
                () => {
                  refreshRecord({ key: 'M08F_tattoo_quickStartGuide' });
                  window.open(
                    'https://doc.labelife.net/upload/documents/tattoo/M08F_QuickGuideBook.pdf'
                  );
                }
              "
              >Quick Start Guide</a
            >
            |
            <a
              @click="
                () => {
                  refreshRecord({ key: 'M08F_tattoo_manual' });
                  window.open(
                    'https://doc.labelife.net/upload/documents/tattoo/Phomemo-M08F-竖版英文（含纹身操作）.pdf'
                  );
                }
              "
              target="_blank"
              title="Click to learn more"
              >Phomemo M08F Manual</a
            >
          </div>
          <hr
            style="color: rgba(51, 61, 71, 0.3); margin-top: 40px"
            v-show="!isMobile()"
          />
          <p>
            Phomemo Thermal Printer Paper For M08F, Please click below Link:
          </p>
          <div class="linkDiv" ref="howToVideosRef">
            <!-- <a
              @click="
                () => {
                  refreshRecord({ key: 'M08F_tattoo_suppliesSales' });
                  window.open('https://www.amazon.com/dp/B09M42139S');
                }
              "
              target="_blank"
              title="Click to learn more"
              >A4 Thermal Paper (8.27"x11.69")</a
            >
            | -->
            <a
              @click="
                () => {
                  refreshRecord({ key: 'M08F_tattoo_suppliesSales' });
                  window.open('https://www.amazon.com/dp/B0BRKB4KWB');
                }
              "
              target="_blank"
              title="Click to learn more"
              >A4 Tattoo Transfer Paper (8.27"x11.69")</a
            >
            |
            <a
              @click="
                () => {
                  refreshRecord({ key: 'M08F_tattoo_suppliesSales' });
                  window.open('https://www.amazon.com/dp/B0CXT356HP');
                }
              "
              target="_blank"
              title="Click to learn more"
              >3MM Tattoo Fake Skin</a
            >
            <p>
              <a
                href="https://www.amazon.co.uk/dp/B0BRMJ2MYW"
                target="_blank"
                title="Click to learn more"
                >UK M08F Tattoo Printer</a
              >
              /
              <a
                href="https://www.amazon.co.uk/dp/B0BRKB4KWB"
                target="_blank"
                title="Click to learn more"
                >Tattoo Transfer Paper</a
              >
            </p>
            <p>
              <a
                href="https://www.amazon.de/dp/B0BVY54JGT"
                target="_blank"
                title="Click to learn more"
                >DE M08F Tattoo Drucker</a
              >
              /
              <a
                href="https://www.amazon.de/dp/B0BRKB4KWB"
                target="_blank"
                title="Click to learn more"
                >Tattoo Transfer Papier</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv">
      <div class="videoTitle">
        <img
          src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/videosIcon.png?v=1663240699"
          style="margin: 0"
        />
        <div class="textContainer">HOW-TO VIDEOS</div>
      </div>
      <br />
      <div class="videosDivE">
        <div class="leftDiv">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/2235.png?v=1644832141"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a class="a-link">For Mac</a>
        </div>
        <div class="centerDiv">
          <p>MacOS 10.14</p>
          <p>MacOS 10.15</p>
          <p>MacOS 10.11</p>
          <p>MacOS 12</p>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            poster="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/mac_07abd8e3-5f30-447f-943f-57c577cd640b.png?v=1662456329"
            style="width: 100%"
            id="M08F_tattoo_macVideo"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/tatto_MacOs.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>

      <hr
        style="color: rgba(51, 61, 71, 0.3); margin: 0 8%; margin-bottom: 6px"
      />
      <div class="videosDivE">
        <div class="leftDiv">
          <img
            class="videoLogoImg"
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/windows-phone-logo-topic.png?v=1644832318"
            style="display: block; margin: 0 auto"
          />
          <a class="a-link">For Windows</a>
        </div>
        <div class="centerDiv">
          <p>Windows 7 (32 and 64 bit)</p>
          <p>Windows 8 (32 and 64 bit)</p>
          <p>Windows 10 (32 and 64 bit)</p>
          <p>Windows 11 (64 bit)</p>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            poster="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/windows.png?v=1662456328"
            style="width: 100%"
            id="M08F_tattoo_windowsVideo"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/tatto_Windows.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
      <hr
        style="color: rgba(51, 61, 71, 0.3); margin: 0 8%; margin-bottom: 6px"
      />

      <div class="videosDivE">
        <div class="leftDiv" style="padding-top: 3%">
          <img
            src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/chrome.png?v=1673937307"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a class="a-link">For Chrome OS</a>
        </div>
        <div class="centerDiv" style="padding-top: 6%">
          <p>Download Extension For Chrome OS</p>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 100%"
            id="M08F_tattoo_chromeVideo"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/tatto_chrome.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>

      <hr
        style="color: rgba(51, 61, 71, 0.3); margin: 0 8%; margin-bottom: 6px"
      />
      <div class="videosDivE">
        <div class="leftDiv">
          <img
            src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/pm246sLinux.png?v=1688530177"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a class="a-link">For Linux</a>
        </div>
        <div class="centerDiv" style="padding-top: 5%">
          <p>Download Driver For Linux System</p>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 100%"
            id="M08F_tattoo_linuxVideo"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/tatto_linux.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>

      <hr
        style="color: rgba(51, 61, 71, 0.3); margin: 0 8%; margin-bottom: 6px"
      />
      <div class="videosDivE">
        <div class="leftDiv">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/app.png?v=1654666291"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a class="a-link">APP for Smart Phone</a>
        </div>
        <div class="centerDiv" style="padding-top: 3%">
          <p>Phomemo App For IOS Device</p>
          <p>Phomemo App For Android device</p>
        </div>
        <div class="rightDiv">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            id="M08F_tattoo_APPVideo"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/tatto_phone.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv" ref="driversRef">
      <div class="videoTitle">
        <img
          src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/driversIcon.png?v=1663240538"
          style="margin: 0"
        />
        <div class="textContainer">DRIVERS</div>
      </div>
      <div class="downloadTitleBar">
        <span>M08F series Driver setup package (Windows)</span>
        <div
          class="downloadBtnNew"
          title="Click to download：https://oss.qu-in.ltd/Phomemo/QY_Printer_Driver_Win.zip"
          @click="
            () => {
              refreshRecord({ key: 'M08F_tattoo_windowsDrivers' });
              window.open(
                'https://oss.qu-in.ltd/Phomemo/QY_Printer_Driver_Win.zip'
              );
            }
          "
        >
          DOWNLOAD
          <img
            src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/downloadIconMini.png?v=1698800024"
          />
        </div>
        <span class="showSizeDiv" title="File Size">(2.26 MB)</span>
      </div>
      <div class="downloadText">
        <p>
          OPERATING SYSTEM: Windows 7, Windows 8, Windows 10(32 and 64 bit)
          Windows 11(64 bit)
        </p>
      </div>
      <br v-show="!isMobile()" />
      <hr
        style="
          color: rgba(51, 61, 71, 0.3);
          margin: 0 1% 0 4%;
          margin-bottom: 6px;
        "
      />
      <div class="downloadTitleBar">
        <span>M08F series Driver setup package (Windows ARM)</span>
        <div
          class="downloadBtnNew"
          title="Click to download：https://oss.qu-in.ltd/Phomemo/QY_Printer_Driver_Win.zip"
          style="top: 20px"
          @click="
            () => {
              refreshRecord({ key: 'M08F_tattoo_ARMDrivers' });
              window.open(
                'https://oss.qu-in.ltd/Phomemo/QY_Printer_Driver_Win.zip'
              );
            }
          "
        >
          DOWNLOAD
          <img
            src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/downloadIconMini.png?v=1698800024"
          />
        </div>
        <span class="showSizeDiv" title="File Size" style="top: 31px"
          >(1.31 MB)</span
        >
      </div>
      <br v-show="!isMobile()" />
      <br v-show="!isMobile()" />
      <hr
        style="
          color: rgba(51, 61, 71, 0.3);
          margin: 0 1% 0 4%;
          margin-bottom: 6px;
        "
      />

      <div class="downloadTitleBar">
        <span>M08F series Driver setup package (Mac)</span>
        <div
          class="downloadBtnNew"
          title="Click to download：https://oss.qu-in.ltd/Phomemo/QY_Printer_Driver_Mac.zip"
          @click="
            () => {
              refreshRecord({ key: 'M08F_tattoo_macDrivers' });
              window.open(
                'https://oss.qu-in.ltd/Phomemo/QY_Printer_Driver_Mac.zip'
              );
            }
          "
        >
          DOWNLOAD
          <img
            src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/downloadIconMini.png?v=1698800024"
          />
        </div>
        <span class="showSizeDiv" title="File Size">(12.0 MB)</span>
      </div>
      <div class="downloadText">
        <p>OPERATING SYSTEM: macOS 10.14, macOS 10.15, macOS 10.11, macOS 12</p>
      </div>
      <br v-show="!isMobile()" />
      <hr
        style="
          color: rgba(51, 61, 71, 0.3);
          margin: 0 1% 0 4%;
          margin-bottom: 6px;
        "
      />

      <div class="downloadTitleBar">
        <span>MO8F Series Extension setup (Chrome OS)</span>
        <div
          class="downloadBtnNew"
          title="Click to download"
          style="top: 20px"
          @click="
            () => {
              refreshRecord({ key: 'M08F_tattoo_chromeDrivers' });
              window.open(
                'https://chrome.google.com/webstore/detail/labelife/fahkjfnppokdemlfodklgmdklmcllidl'
              );
            }
          "
        >
          CLICK HERE
          <img
            src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/downloadIconMini.png?v=1698800024"
          />
        </div>
        <!-- <span class="showSizeDiv" title="File Size">(528 KiB)</span> -->
      </div>
      <br v-show="!isMobile()" />
      <br v-show="!isMobile()" />
      <hr
        style="
          color: rgba(51, 61, 71, 0.3);
          margin: 0 1% 0 4%;
          margin-bottom: 6px;
        "
      />

      <div class="downloadTitleBar">
        <span>M08F series Driver setup package (Linux)</span>
        <div
          class="downloadBtnNew"
          title="Click to download"
          style="top: 20px"
          @click="
            () => {
              refreshRecord({ key: 'M08F_tattoo_linuxDrivers' });
              window.open(
                'https://oss.qu-in.life/Tianyi/QY_Printer_Driver_Linux_EN.zip'
              );
            }
          "
        >
          DOWNLOAD
          <img
            src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/downloadIconMini.png?v=1698800024"
          />
        </div>
        <span class="showSizeDiv" title="File Size" style="top: 31px"
          >(351 KB)</span
        >
      </div>
    </div>

    <div class="howToVideosDiv" style="margin-top: 40px" ref="appDownloadRef">
      <div class="videoTitle">
        <img
          src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/driversIcon.png?v=1663240538"
          style="margin: 0"
        />
        <div class="textContainer">APP</div>
      </div>
      <div class="appDownloadContainer">
        <div class="everyItemArea">
          <img :src="appDownIcon" style="max-width: 150px" />
          <h3>Phomemo APP - IOS</h3>
          <p>Easily print from your iOS device with the Phomemo App</p>
          <p>
            <a
              @click="
                () => {
                  refreshRecord({ key: 'M08F_tattoo_AppStore' });
                  window.open(
                    'https://apps.apple.com/us/app/phomemo/id1456102145'
                  );
                }
              "
              target="_blank"
              title="Click to download"
              >LEARN MORE</a
            >
          </p>
        </div>
        <div class="dividerLineDiv"></div>
        <div class="everyItemArea">
          <img :src="appDownIcon" style="max-width: 150px" />
          <h3>Phomemo APP - Android</h3>
          <p>Easily print from your Android device with the Phomemo App</p>
          <p>
            <a
              target="_blank"
              @click="
                () => {
                  refreshRecord({ key: 'M08F_tattoo_GooglePlay' });
                  window.open(
                    'https://play.google.com/store/apps/details?id=com.quyin.phomemo'
                  );
                }
              "
              title="Click to download"
              >LEARN MORE</a
            >
          </p>
        </div>
      </div>
    </div>

    <div class="howToVideosDiv faqBarDiv" ref="faqRef">
      <div class="videoTitle">
        <img
          src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/faqsIcon.png?v=1663316214"
          style="margin: 0"
        />
        <div class="textContainer" title="Frequently Asked Questions">FAQ</div>
      </div>
      <div class="faq-content-area" style="margin-top: 30px">
        <div class="faq-container">
          <div
            class="faq-item"
            v-for="(item, index) in faqDataApp"
            :key="index"
          >
            <div class="faq-title" @click="clickQuestion2(item, index)">
              <span v-text="item.title"></span>
              <img
                src="https://cdn.shopify.com/s/files/1/0595/1940/2172/files/f10e2c4832c0faf086185700b226c940.png?v=1646813187"
                class="downArrow"
                v-show="activeQuestion2.index === index"
              />
              <img
                src="https://cdn.shopify.com/s/files/1/0595/1940/2172/files/a016b412f93b877a827866a90379da25.png?v=1646813168"
                class="downArrow"
                v-show="activeQuestion2.index !== index"
              />
            </div>
            <div class="faq-scroll-area">
              <div
                class="faq-content"
                v-show="activeQuestion2.index === index"
                v-for="child in item.details"
              >
                <div class="content-title" v-html="child.theme"></div>
                <br v-show="child.hasBr" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--   联系方式 -->
    <div class="customServiceDiv">
      <div class="everyRow">
        Email：
        <a
          @click="
            () => {
              refreshRecord({ key: 'M08F_tattoo_email' });
              window.open('mailto:support@phomemo.com');
            }
          "
          >support@phomemo.com</a
        >
      </div>
      <div class="everyRow">Tel：+1 855 957 5321(US ONLY)</div>
      <div class="everyRow">WhatsApp：+86 15338193665</div>
    </div>

    <div class="back-to-top-div">
      <a @click="backTop"><img :src="toTopIcon" /><br />Back to top</a>
    </div>
  </div>
</template>

<script>
import { tattooFaq } from "./dataConfig.js";
import { refreshRecord, sensorsRecord } from "@/util.js";
const isMobile = () => {
  // 返回true为移动端，否则为pc端
  if (!window.navigator) return true;
  const flag = window.navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag ? true : false;
};
export default {
  name: "tattoo",
  props: {},
  data() {
    return {
      faqDataApp: tattooFaq,
      activeQuestion2: {},
      isMobile,
      window,
      appDownIcon: require("@/assets/appDownIcon.jpg"),
      clickName: "",
      toTopIcon: require("@/assets/toTopIcon.png"),
      refreshRecord,
    };
  },
  mounted() {
    this.listenVideo("M08F_tattoo_macVideo");
    this.listenVideo("M08F_tattoo_windowsVideo");
    this.listenVideo("M08F_tattoo_chromeVideo");
    this.listenVideo("M08F_tattoo_linuxVideo");
    this.listenVideo("M08F_tattoo_APPVideo");
    sensorsRecord({ key: "M08F_tattoo_view" }, 1);
    sensorsRecord({ key: "M08F_tattoo_WebStay" }, 3);
  },
  methods: {
    listenVideo(videoId) {
      document.getElementById(videoId).addEventListener("play", function () {
        // console.log("视频开始播放了！");
        refreshRecord({ key: videoId });
      });
    },
    clickQuestion2(item = {}, index) {
      const { activeQuestion2 } = this;
      if (
        activeQuestion2.index === undefined ||
        activeQuestion2.index !== index
      ) {
        this.activeQuestion2 = { ...item, index };
        refreshRecord({ key: "M08F_tattoo_FAQ" + (index + 1) });
      } else this.activeQuestion2 = {};
    },
    backTop() {
      const scrollToTop = () => {
        const c = document.documentElement.scrollTop || document.body.scrollTop;
        if (c > 0) {
          window.requestAnimationFrame(scrollToTop);
          window.scrollTo(0, c - c / 8);
        }
      };
      scrollToTop();
      this.clickName = "";
    },

    turnToItem(refName = "") {
      const ref = this.$refs[refName];
      this.clickName = refName;
      if (ref && ref.scrollIntoView) ref.scrollIntoView();
    },
  },
};
</script>

<style lang="less" src="./m08f_2.less" />



// WEBPACK FOOTER //
// src/view/guides/tattoo.vue